export const STARTING = "STARTING";
export const RUNNING = "RUNNING";
export const STOPPING = "STOPPING";
export const STOPPED = "STOPPED";
export const SUCCEEDED = "SUCCEEDED";
export const FAILED = "FAILED";
export const TIMEOUT = "TIMEOUT";
